module.exports = __webpack_public_path__ + "img/04_Health&SafetyPromoter.png";